import React, { PropsWithChildren, useEffect, useRef, useState } from 'react'
import Flickity from 'react-flickity-component'
import { FlickityRefObject } from '../../types/FlickityRefObject'
import { FeatureNewsCarouselSectionProps } from './FeatureNewsCarouselSection'
import { StyledFeatureNewsCarouselContainer } from './styledCarouselElements'
import { StyledFlickityContentComponent, StyledFlickityImageComponent } from './styledFlickityCarousel'

export type FlickityComponentProps = Omit<React.ComponentProps<typeof Flickity>, 'flickityRef'> & {
  layout: 'vertical' | 'horizontal'
}

export const FlickityComponent: React.FC<PropsWithChildren<FlickityComponentProps>> = ({ layout, children, options={}, ...props }) => {
  const flickityRefImage = useRef(null) as FlickityRefObject
  const flickityRefContent = useRef(null) as FlickityRefObject
  const [visibility, setVisibility] = useState(false)

  // Handle change other flickty content if flickty image change (and vice versa)
  useEffect(() => {
    const img = flickityRefImage.current?.flkty
    const content = flickityRefContent.current?.flkty

    if (img && content) {
      img.on('change', (index: number) => {
        content.select(index)
      })
    }

    if (content && img) {
      content.on('change', (index: number) => {
        img.select(index)
      })
    }

    setTimeout(() => {
      setVisibility(true)
    }, 2000)
  }, [])

  return (
    <StyledFeatureNewsCarouselContainer>
      <StyledFlickityImageComponent
        ref={flickityRefImage}
        reloadOnUpdate={true}
        $visibility={visibility}
        options={{
          ...options,
          contain: true,
          cellAlign: 'left',
          pageDots: false,
          initialIndex: 0,
          prevNextButtons: React.Children.toArray(children).length > 1,
        }}
        {...props}>
        {
          React.Children.toArray(children).map((section, index) => {
            const flickitySection = React.cloneElement(section as React.ReactElement<FeatureNewsCarouselSectionProps>)
            
            return (
              <React.Fragment key={index}>
                {
                  flickitySection.props.children.map(content => {
                    if (content.props.image === true) {
                      return content
                    }

                    return null
                  })
                }
              </React.Fragment>
            )
          })
        }
      </StyledFlickityImageComponent>
      <StyledFlickityContentComponent ref={flickityRefContent} $isContent={true} {...props}
        reloadOnUpdate={true}
        $visibility={visibility}
        options={{
          ...options,
          contain: true,
          cellAlign: 'left',
          initialIndex: 0,
          pageDots: React.Children.toArray(children).length > 1,
          prevNextButtons: false,
        }}
      >
        {
          React.Children.toArray(children).map((section, index) => {
            const flickitySection = React.cloneElement(section as React.ReactElement<FeatureNewsCarouselSectionProps>)
            
            return (
              <React.Fragment key={index}>
                {
                  flickitySection.props.children.map(content => {
                    if (content.props.contentSection === true) {
                      return content
                    }
                    
                    return null
                  })
                }
              </React.Fragment>
            )
          })
        }
      </StyledFlickityContentComponent>
    </StyledFeatureNewsCarouselContainer>
  )
}
